// Sfeerbeelden (gegenereerd) — productfoto's blijven de echte Shopify-beelden.
export const media = {
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/28fb32ab-2924-4ca6-b926-e52fdf6ca12b.jpg",
  dining: "https://cdn.magicpatterns.com/patterns/generated-images/b70aada1-c252-4cda-8bdc-77d411907d53.jpg",
  studio: "https://cdn.magicpatterns.com/patterns/generated-images/40f8ac9c-a158-407f-881d-058d2fc87bec.jpg",
  lampMood: "https://cdn.magicpatterns.com/patterns/generated-images/2c705c7f-5eb1-4500-aec2-eea7a063bdf9.jpg",
  gifts: "https://cdn.magicpatterns.com/patterns/generated-images/6f22aa57-911e-4f33-b9a3-49a29170d688.jpg",
};
